// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","203":"f4d8d3e0b8adfef3d833","228":"99f595a64106cb4dc018","243":"307c1cf31df043fbcfea","556":"5d0be4adc9c1b231c0ec","720":"e986df59120b9443ada3","852":"cdd1839a42ad1571d402"}[chunkId] + ".bundle.js";
};